export default "__VITE_ASSET__DErIYFle__"